import { useSelector } from 'react-redux'

import { selectIsOnTrial, selectPaidFeatures } from '@/app/slices/organisationSlice'

import { useToolBoxTreatments } from './useToolBoxTreatments'

/**
 * Custom hook to determine if the user has access to Nest View feature
 * Access is granted if ANY of the following conditions are true:
 * 1. Organization is on a trial
 * 2. Organization's Stripe subscription includes material_consumption = true
 * 3. Split.io feature flag ToolBox_EnableNestView is enabled for the user
 *
 * @returns {boolean} - True if user has access to Nest View feature
 */
export function useNestViewAccess() {
    const isOnTrial = useSelector(selectIsOnTrial)
    const paidFeatures = useSelector(selectPaidFeatures)
    const { showEnableNestView } = useToolBoxTreatments()

    // Access granted through Stripe subscription metadata
    const hasMaterialConsumption = paidFeatures?.hasMaterialConsumptionModeOptions ?? false

    // Access granted through ANY of the three paths
    return isOnTrial || hasMaterialConsumption || showEnableNestView
}
